module.exports = __webpack_public_path__ + "media/images/ohap_edit_on-fc9ff4a26837016710968f37529f9cb7.png";